import { render, staticRenderFns } from "./editColumn.vue?vue&type=template&id=60881661&scoped=true"
import script from "./editColumn.vue?vue&type=script&lang=js"
export * from "./editColumn.vue?vue&type=script&lang=js"
import style0 from "./editColumn.vue?vue&type=style&index=0&id=60881661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60881661",
  null
  
)

export default component.exports